var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 9,
    height: 9,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 9,
    height: 9,
    rx: 1,
    stroke: "#146EB4",
    strokeWidth: 3.4,
    mask: "url(#path-1-inside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 9,
    height: 9,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 9,
    height: 9,
    rx: 1,
    stroke: "#146EB4",
    strokeWidth: 3.4,
    mask: "url(#path-2-inside-2)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 1.99997,
    width: 9,
    height: 9,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 1.99997,
    width: 9,
    height: 9,
    rx: 1,
    stroke: "#146EB4",
    strokeWidth: 3.4,
    mask: "url(#path-3-inside-3)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 9,
    height: 9,
    rx: 1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 9,
    height: 9,
    rx: 1,
    stroke: "#146EB4",
    strokeWidth: 3.4,
    mask: "url(#path-4-inside-4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridActive);
export default __webpack_public_path__ + "static/media/grid-active.6752d2509bdbf30bf05cd3da6a03feed.svg";
export { ForwardRef as ReactComponent };